import { put } from "redux-saga/effects";
import importer from "common/importer";
import i18next from "i18next";
import { getMinStaticContent } from "@takedapdt/biolife-cms-kit";
const ChatbotActions = importer("Stores/Chatbot/Actions");
const PublicContentActions = importer("Stores/PublicContent/Actions");
const { calculateReadTime } = importer("Helpers/Utils", null);

export default function* main({ slug = "" }) {
  try {
    let data;
    const finalSlug = slug.length
      ? { lang: i18next.language, filters: { field_slug_value: slug } }
      : { lang: i18next.language };
    let sortedResult = [];
    const result = [];
    const newsCategoryList = [];
    yield put(PublicContentActions.getNewsPageLoading());

    data = yield getMinStaticContent("news", finalSlug);
    yield put(ChatbotActions.showHideChatbot(true));
    if (data?.length) {
      for (const content of data) {
        if (content.metadata) {
          if (content.metadata?.field_category)
            newsCategoryList.push(
              (content.metadata?.field_category).split("_").join(" ")
            );

          let readTime = content.metadata?.field_read_time;
          if (!readTime || readTime === undefined) {
            // Calculate read time if field_read_time is null or undefined
            readTime = calculateReadTime(content);
            // Assign read time to field_read_time
            content.metadata.field_read_time = readTime;
          }

          result.push({
            ...content.metadata,
            contents: content.contents,
          });
        }
      }
    }
    if (!finalSlug["filters"]) {
      sortedResult = result.sort(
        (a, b) => new Date(b.created).valueOf() - new Date(a.created).valueOf()
      );
    }
    yield put(
      PublicContentActions.getNewsPageSuccess(
        result && result.length ? sortedResult : data
      )
    );
  } catch (error) {
    yield put(PublicContentActions.getNewsPageFailure(error));
  }
}
